import { DetailItem, DetailList } from '@/components/ui/detail-list'
import type { TicketRequester } from '@/types/ticket'

// Who raised the ticket, first thing in the staff rail: the details a reply
// most often needs, without opening a disclosure.
export function RequesterDetails({ requester }: { requester: TicketRequester }) {
  return (
    <section data-testid="requester" aria-label="Requester" className="mb-5 border-b border-etn-border-hairline pb-5">
      <DetailList>
        <DetailItem label="Name">{requester.name || '—'}</DetailItem>
        <DetailItem label="Email">
          {requester.email
            ? (
              <a href={`mailto:${requester.email}`} className="break-all text-etn-accent-text-active hover:underline">
                {requester.email}
              </a>
            )
            : '—'}
        </DetailItem>
        <DetailItem label="Company">{requester.companyName || '—'}</DetailItem>
        <DetailItem label="Role">{requester.roleName || '—'}</DetailItem>
      </DetailList>
    </section>
  )
}
